const SavedFilterTypes = {
	user: 'user',
	group: 'group',
};

export default SavedFilterTypes;
